module.exports = __webpack_public_path__ + "static/media/26.6d993f04.wav";